module.exports = __webpack_public_path__ + "assets/img/11_1852_big.028bab35.jpg";